import { render, staticRenderFns } from "./Wave.vue?vue&type=template&id=36ce1992"
import script from "./Wave.vue?vue&type=script&lang=js"
export * from "./Wave.vue?vue&type=script&lang=js"
import style0 from "./Wave.vue?vue&type=style&index=0&id=36ce1992&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports